import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { UserState, UserStateData } from 'frontend/types/lessons/lesson';
import { LessonSaveStateInputs, LessonResetStateInputs } from 'frontend/types/lessons/requests';
import { apiRouter } from 'frontend/router';
import { postData } from 'frontend/utils/ajax';
import { appendGetParams } from 'frontend/utils/urls';
import { AsyncThrottle } from 'frontend/utils/asyncThrottle';

const saveStateThrottle = new AsyncThrottle();

const userStateModule: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    userState: undefined,
  },
  mutations: {
    setValue(state: UserState, value: UserStateData) {
      state.userState = value;
    },
  },
  actions: {
    async save({ commit }, { params, data }: LessonSaveStateInputs): Promise<void> {
      const url = apiRouter().resolve({ params, name: 'lesson_userstate_save' });
      await saveStateThrottle.throttle(async () => {
        const response = await postData(url.href, data);
        commit('globals/setStreakData', response.results.streak, { root: true });
      });
    },
    async reset({}, { params, data }: LessonResetStateInputs): Promise<void> {
      const url = apiRouter().resolve({
        params,
        name: 'lesson_userstate_reset',
      });
      await postData(appendGetParams(url.href, data), {});
    },
  },
  getters: {},
};

export default userStateModule;
